import UserDropMenu from '../menu/UserDropMenu';
import { Breadcrumbs } from '../breadcrumbs/breadcrumbs';

export default function NavBar() {
  return (
    <div className="h-16 px-8 py-3 flex sticky bg-white top-0 items-center justify-between shadow-sm z-10">
      <div className="font-medium text-base">
        <Breadcrumbs />
      </div>
      <UserDropMenu />
    </div>
  );
}
